<template>
  <div class="custom-searchable-dropdown-container" v-click-outside="closeDropdown"
    :class="{ 'is-disabled': disabled }"
  >
    <button class="custom-searchable-btn-dropdown" @click.stop="toggleDropdown"
      :disabled="disabled"
    >
      <span class="custom-searchable-btn-text">
        {{ selectedItem ? selectedItem[labelKey] : displayText || placeholder }}
      </span>
      <i v-if="dropdownOpen" class="fa fa-chevron-up custom-searchable-btn-icon"></i>
      <i v-else class="fa fa-chevron-down custom-searchable-btn-icon"></i>
    </button>

        <div class="custom-searchable-dropdown-menu" v-if="dropdownOpen">
            <input v-if="searchable" type="text" placeholder="Search..." v-model="searchQuery"
                class="custom-searchable-dropdown-search" />
      <ul>
                <li v-for="(item, index) in filteredItems" :key="index" @click="selectItem(item)">
          {{ item[labelKey] }}
        </li>
      </ul>
            <div v-if="filteredItems.length === 0" class="custom-searchable-dropdown-item empty">
        No matching items found
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
            required: true
    },
    labelKey: {
      type: String,
            default: 'name'
    },
    searchable: {
      type: Boolean,
            default: false
    },
    placeholder: {
      type: String,
            default: 'Select an option'
    },
    initialValue: {
      type: [String, Number, Object],
            default: null
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dropdownOpen: false,
            searchQuery: '',
            selectedItem: null
    };
  },
  computed: {
    filteredItems() {
      if (!this.searchQuery) return this.items;
            return this.items.filter(item =>
                item[this.labelKey].toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    displayText() {
      if (this.selectedItem) return this.selectedItem[this.labelKey];
      if (this.initialValue) {
                if (typeof this.initialValue === 'object') {
          return this.initialValue[this.labelKey];
        }
                const foundItem = this.items.find(item => item[this.labelKey] === this.initialValue);
        return foundItem ? foundItem[this.labelKey] : this.placeholder;
      }
      return this.placeholder;
        }
  },
  methods: {
    toggleDropdown() {
        this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
    selectItem(item) {
      this.selectedItem = item;
            this.$emit('select', item);
      this.closeDropdown();
    },
    clearSelection() {
      this.selectedItem = null;
            this.searchQuery = '';
            this.$emit('select', null); // Notify parent that selection is cleared
      this.closeDropdown();
        }
  },
  watch: {
    initialValue: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
                    if (typeof newVal === 'object') {
            this.selectedItem = newVal;
          } else {
                        this.selectedItem = this.items.find(item => item[this.labelKey] === newVal) || null;
                    }
                }
          }
        }
    }
};
</script>

<style>
.custom-searchable-dropdown-container.is-disabled {
  opacity: 0.6;
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Dropdowns/SearchableDropdown.vue